import { DeviceModeState } from '@redux/person/personTypes';
import { BedroomIcon, LivingSpaceIcon } from 'components/Icons';

export const DeviceModeValues = {
  [DeviceModeState.BEDROOM]: {
    icon: BedroomIcon,
    title: 'Bedroom'
  },
  [DeviceModeState.LIVING_SPACE]: {
    icon: LivingSpaceIcon,
    title: 'Living space'
  }
};

export const getDeviceModeValue = ({ mode, ending = '' }: { mode?: Nullable<DeviceModeState>; ending?: string }) => {
  const currentMode = mode && DeviceModeValues[mode] ? DeviceModeValues[mode] : undefined;
  return {
    title: currentMode ? `${currentMode.title}${ending ? ` ${ending}` : ''}` : 'N/A',
    icon: currentMode ? currentMode.icon : undefined
  };
};
